/* eslint-disable @typescript-eslint/no-empty-function */
export const actually =
  process.env.DEBUG === 'true'
    ? console
    : {
        // These should still work in production mode
        /* eslint-disable no-console */
        assert: console.assert,
        clear: console.clear,
        log: console.log,
        dir: console.dir,
        dirxml: console.dirxml,
        error: console.error,
        group: console.group,
        groupCollapsed: console.groupCollapsed,
        groupEnd: console.groupEnd,
        table: console.table,
        warn: console.warn,
        /* eslint-enable no-console */

        // These should always be disabled in production mode
        /* eslint-disable @typescript-eslint/no-unused-vars */
        count: (_label?: string) => {},
        countReset: (_label?: string) => {},
        debug: (_message?: unknown, ..._optionalParams: unknown[]) => {},
        info: (_message?: unknown, ..._optionalParams: unknown[]) => {},
        profile: (_label?: string) => {},
        profileEnd: (_label?: string) => {},
        time: (_label?: string) => {},
        timeEnd: (_label?: string) => {},
        timeLog: (_label?: string, ..._data: unknown[]) => {},
        trace: (_message?: unknown, ..._optionalParams: unknown[]) => {},
        timeStamp: (_label?: string) => {},
        /* eslint-enable @typescript-eslint/no-unused-vars */
      };
